import { MapPin } from 'lucide-react'

import Avatar from '@/elements/Avatar'
import BackLink from '@/elements/BackLink'
import Text from '@/elements/Text'
import Flex from '@/elements/Flex'
import { FuzzyVerified } from '@/assets'
import { colors } from '@/utils/theme'
import useBreakpoints from '@/hooks/useBreakpoints'

import './ProfileHeader.scss'

interface ProfileHeaderProps {
  avatar?: string
  cover?: string
  name: string
  location: string
  group: string
  position: string
  verified: boolean
}

function ProfileHeader({
  avatar,
  cover,
  name,
  location,
  group,
  position,
  verified,
}: ProfileHeaderProps) {
  const { isMobile } = useBreakpoints()

  const style = {
    '--cover-image': isMobile ? `url(${avatar})` : `url(${cover})`,
  } as React.CSSProperties

  return (
    <Flex wfull className='profile-header' style={style}>
      <Flex wfull gap={3} p={4} className='profile-header-back'>
        <BackLink variant='dark' />
      </Flex>
      <Flex inline wfull gap={4} p={4} className='profile-header-info'>
        <Avatar
          name={name}
          size='extraLarge'
          src={avatar}
        />
        <Flex className='profile-header-info-content'>
          <Flex inline align='center' gap={2}>
            <MapPin size={18} color={colors['black']} />
            <Text color='black'>{location}</Text>
          </Flex>
          <Flex inline align='center' gap={2} pb={2}>
            <Text variant='h1' color='black'>{name}</Text>
            {verified ? <FuzzyVerified /> : null}
          </Flex>
          <Text variant='h3' color='black' style={{ fontWeight: 400 }}>
            {group} • {position}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default ProfileHeader
